import { combineReducers } from 'redux';
import common from './common';
import checkinSync from './checkinSync';

export default combineReducers({
  common,
   checkinSync,
});


